import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import CalendlyController from './Calendly.utils';
import useCalendlyEventListener from './hooks/use-calendly-event-listener';
import Script from '../../../../components/Script';
import { STRATEGY_AFTER_USER_INTERACTION } from '../../../../components/Script/Script.constants';
import { Helmet } from '../../../foundation/components/HelmetProvider';
import { createComponent } from '../../../foundation/services/components';
import { INLINE_CALENDAR, POPUP_CALENDAR } from '../../constants';
import './Calendly.css';
var defaultProps = {
  mode: INLINE_CALENDAR,
  width: 1000,
  height: 660,
  popupTrigger: /*#__PURE__*/React.createElement(Button, {
    content: "Schedule"
  }),
  onEventScheduled: null,
  onDateAndTimeSelected: null,
  onEventTypeViewed: null,
  onProfilePageViewed: null
};
export default function Calendly(_ref) {
  var link = _ref.link,
    mode = _ref.mode,
    width = _ref.width,
    height = _ref.height,
    popupTrigger = _ref.popupTrigger,
    onEventScheduled = _ref.onEventScheduled,
    onDateAndTimeSelected = _ref.onDateAndTimeSelected,
    onEventTypeViewed = _ref.onEventTypeViewed,
    onProfilePageViewed = _ref.onProfilePageViewed;
  if (_isEmpty(link)) {
    return null;
  }
  if (mode === POPUP_CALENDAR && _isEmpty(popupTrigger)) {
    return null;
  }
  useCalendlyEventListener({
    onEventScheduled: onEventScheduled,
    onDateAndTimeSelected: onDateAndTimeSelected,
    onEventTypeViewed: onEventTypeViewed,
    onProfilePageViewed: onProfilePageViewed
  });
  var url = CalendlyController.getUrl(link);
  var _ref2 = popupTrigger || {},
    popupProps = _ref2.props;
  function showPopup() {
    var _ref3 = popupProps || {},
      onClick = _ref3.onClick;
    CalendlyController.showPopup(url);
    if (onClick) {
      onClick();
    }
  }
  function getPopupTrigger() {
    return createComponent(popupTrigger, _objectSpread(_objectSpread({}, popupProps), {}, {
      onClick: showPopup
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "calendar calendly"
  }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
    href: "https://calendly.com/assets/external/widget.css",
    rel: "stylesheet",
    async: true
  })), /*#__PURE__*/React.createElement(Script, {
    src: "https://assets.calendly.com/assets/external/widget.js",
    strategy: STRATEGY_AFTER_USER_INTERACTION
  }), mode === INLINE_CALENDAR && /*#__PURE__*/React.createElement("div", {
    className: "calendly-inline-widget",
    "data-url": url,
    style: {
      width: width,
      height: height
    }
  }), mode === POPUP_CALENDAR && /*#__PURE__*/React.createElement("div", {
    className: "calendly-popup-trigger-container"
  }, getPopupTrigger()));
}
Calendly.defaultProps = defaultProps;